<template>
  <div class="bg-div">
    <img
      class="bg-img"
      src="@/assets/images/company-contact-bg.png"
    >
    <p class="p-title">我们的联系方式</p>
    <div class="div-line"></div>
    <p class="p-des">为您定制专属服务</p>
    <div class="div-phone">
      <p class="p-phone">{{phone}}</p>
    </div>
  </div>
</template>

<script>
import constant from "@/assets/constant";
export default {
  name: "CompanyContact",
  data() {
    return {
      phone: constant.phoneNo,
    };
  },
};
</script>

<style lang="stylus" scoped>
.bg-div {
  position: relative;
}

.bg-img {
  width: 100%;
}

.p-title {
  position: absolute;
  color: #ffffff;
  font-size: 2.3rem;
  top: 5.6rem;
  left: 50%;
  transform: translateX(-50%);
}

.div-line {
  position: absolute;
  width: 6%;
  left: 47%;
  right: 47%;
  height: 0.1rem;
  background-color: #12b7f6;
  top: 9rem;
}

.p-des {
  position: absolute;
  color: #ffffff;
  font-size: 1.5rem;
  top: 9.5rem;
  left: 50%;
  transform: translateX(-50%);
}

.div-phone {
  position: absolute;
  width: 40%;
  height: 15%;
  background-color: rgba(255, 255, 255, 0.3);
  bottom: 9rem;
  left: 50%;
  transform: translateX(-50%);

  .p-phone {
    padding: 0.5rem 0.5rem;
    font-size: 1.9rem;
    color: #ffffff;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/company/components/ContentContact.vue